var Glyphicon = require("components/utility/icons/Glyphicon");

var DropDownNotification = function(props) {
	var className = "dropDownNotification";

	if (props.type == undefined) {
		className += " " + DropDownNotification.success;

	} else {
		className += " " + props.type;
	}

	if (props.icon) {
		var icon = <Glyphicon icon={ props.icon } />
	}

	if (props.title && props.title.trim().length > 0) {
		var title = (
			<strong>{ props.title }</strong>
		);
	}

	if (props.text && props.text.trim().length > 0) {
		if (title) {
			var text = (
				<span>{ " - " } { props.text }</span>
			);
		} else {
			var text = (
				<span>{ props.text }</span>
			);
		}
	}

	return (
		<div className={ className } onClick={ props.onClick } >
			{ icon }{ " " }{ title }{ text }
		</div>
	)
}

DropDownNotification.success = "success";
DropDownNotification.error = "error";

DropDownNotification.propTypes = StrictPropTypes({
	// Glyphicon suffix (like 'remove')
	icon: PropTypes.string,

	// Bold text on the left
	title: PropTypes.string,

	// Normal weight text that comes next
	text: PropTypes.string,

	// Action to take when the notification is clicked on
	onClick: PropTypes.func,

	// The type of alert (success, error, etc.). Default success
	type: PropTypes.oneOf([DropDownNotification.success, DropDownNotification.error])
});

module.exports = DropDownNotification;



// WEBPACK FOOTER //
// ./modules/components/notifications/DropDownNotification.js